export default __webpack_public_path__ + "static/media/logo.4524680e.svg";